import './VulStatusCell.scss';

const VulStatusCell: React.FC<{ status: string; placeholder: string }> = ({ status, placeholder }) => {
  const defaultStatus = `text-${status} ri-checkbox-blank-circle-fill`;

  return (
    <span className="fs-3 text-center">
      <i title={placeholder} className={status === 'circle' ? 'circle' : defaultStatus} />
    </span>
  );
};

export default VulStatusCell;
